<lib-ai-exam-onboarding-shell [brand]="brand" [progressPercent]="100"
    [progressLabel]="'ai-exam-onboarding.progress.ready' | translate" [showProgress]="true" [wideCard]="true">

    <div class="launch-title" translate [translateParams]="{ name: greetingName }">
        ai-exam-onboarding.launch.title
    </div>
    <p class="launch-subtitle" translate>ai-exam-onboarding.launch.subtitle</p>

    @if (contextPills.length > 0) {
    <div class="context-pills">
        @for (pill of contextPills; track pill.labelKey) {
        <div class="pill capitalize">
            <span class="pill-label" translate>{{ pill.labelKey }}</span>
            {{ pill.value }}
        </div>
        }
    </div>
    }

    @if (testCreationError) {
    <div class="error-banner" translate>ai-exam-onboarding.launch.creation-error</div>
    }

    <button type="button" class="onboarding-btn-primary onboarding-btn-primary--full launch-cta"
        [disabled]="loading" (click)="start.emit()">
        @if (!loading) {
        <span translate>{{ ctaKey }}</span>
        } @else {
        <span class="inline-flex items-center justify-center gap-2">
            <mat-spinner [diameter]="20" [strokeWidth]="3"></mat-spinner>
            <span translate>ai-exam-onboarding.launch.loading</span>
        </span>
        }
    </button>
</lib-ai-exam-onboarding-shell>
